import * as React from 'react';

import IInput from './IInput';
import { renderLabel, classNames } from '@features/utils/reactFunctions';

import * as style from './InputStyle.module.scss'

const preventScrollingOnInput = (e: React.WheelEvent<HTMLInputElement>) => { e.currentTarget.blur(); };

export const Input = ({
  label,
  errorMsg,
  className,
  type = 'text',
  ...restProps
}: IInput): JSX.Element => (
  <div className={classNames(style.inputWrapper, className)}>
    {renderLabel(label, style.inputLabel)}
    <input
      className={classNames(style.inputField, errorMsg && style.inputFieldError)}
      type={type}
      onWheelCapture={preventScrollingOnInput}
      {...restProps}
    />
    {renderLabel(errorMsg, style.inputError)}
  </div>
);

export default React.memo(Input);
